module.exports = __webpack_public_path__ + "img/pubcom.58d2ec1.svg";